module.exports = __webpack_public_path__ + "img/20251021.978a5167.webp";